import type { FC } from 'react'

import { Tooltip } from '@skytech/ui'
import AlertDecagramIcon from 'mdi-react/AlertDecagramIcon'
import BanIcon from 'mdi-react/BanIcon'
import CheckDecagramIcon from 'mdi-react/CheckDecagramIcon'
import { twJoin } from 'tailwind-merge'

import { useTranslation } from '@/app/translations/translations-hooks'
import { useIsThreeStepIT } from '@/hooks/access'
import { useLocalDate } from '@/hooks/use-local-date'

import type { CostObjectDetails as CostObjectDetailsType } from '../../resources'

export const EmployeeConsentIndicator: FC<{ consent: CostObjectDetailsType['consent'] }> = ({
  consent,
}) => {
  const translate = useTranslation()
  const { formatDate } = useLocalDate()
  const isThreeStepIT = useIsThreeStepIT()

  if (consent?.isRevoked) {
    return (
      <>
        <BanIcon
          className={twJoin(isThreeStepIT ? 'text-threeStepIT-warning' : 'fill-orange-500')}
        />
        <Tooltip
          anchorId="consent-indicator"
          content={translate('Consent revoked at {date}', {
            date: formatDate({ date: consent.isRevokedDatetime }),
          })}
          size="large"
          place="right"
        />
      </>
    )
  }

  if (consent?.isConsentGiven) {
    return (
      <>
        <CheckDecagramIcon
          className={twJoin(isThreeStepIT ? 'text-threeStepIT-success' : 'fill-green-500')}
        />
        <Tooltip
          anchorId="consent-indicator"
          content={translate('Consent given at {date}', {
            date: formatDate({ date: consent.consentGivenDate }),
          })}
          size="large"
          place="right"
        />
      </>
    )
  }

  return (
    <>
      <AlertDecagramIcon
        className={twJoin(isThreeStepIT ? 'text-threeStepIT-failure' : 'fill-red-500')}
      />
      <Tooltip
        anchorId="consent-indicator"
        content={translate('Consent missing')}
        size="large"
        place="right"
      />
    </>
  )
}
